<template>
  <q-page padding>
    <PageHeader
      title="Upload de Arquivos"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />

    <q-tabs
      v-model="tab"
      dense
      class="text-grey q-mt-md bg-accent"
      active-color="primary"
      indicator-color="primary"
      align="justify"
      narrow-indicator
    >
      <q-tab name="crie" label="CRIE PRODUTOS POR PLANILHA" />
      <q-tab name="atualize" label="ATUALIZE PRODUTOS POR PLANILHA" />
      <q-tab name="remova" label="REMOVA ITENS DO CATÁLOGO" />
      <q-tab name="zerar" label="ZERAR PONTOS DE REPOSIÇÃO DOS ITENS" />
      <q-tab name="desativar" label="DESATIVAR CONTROLE DE LOTE" />
    </q-tabs>

    <q-tab-panels v-model="tab" animated>
      <!-- ===== CRIE PRODUTOS ===== -->
      <q-tab-panel name="crie">
        <div class="row col-12">
          <p class="text-h6 text-brand-5 text-weight-bold">
            CRIE PRODUTOS POR PLANILHA
          </p>
        </div>
        <infot-upload
          :infos="infosCrie"
          :showUnidade="false"
          :activeSlide="activeSlide"
          link="https://multpex-docs.s3.amazonaws.com/templates/controle-funcao/produtos_upload_r3.xlsx"
        />

        <div class="row items-center q-mt-md q-mb-md">
          <div class="col-4">
            <lista-unidades-select />
          </div>
        </div>

        <upload-planilha-layout
          titulo="Enviar planilha de criação de produtos"
          :file="file1"
          :is-drag-over="isDragOver1"
          :submit-disabled="!file1"
          @drag-over="isDragOver1 = true"
          @drag-leave="isDragOver1 = false"
          @drop-file="onDrop(1, $event)"
          @file-selected="(e) => onFileSelected(1, e)"
          @instructions="activeSlide = !activeSlide"
          @submit="enviar(1, 'produto')"
        />
      </q-tab-panel>

      <!-- ===== ATUALIZE PRODUTOS ===== -->
      <q-tab-panel name="atualize">
        <div class="row col-12">
          <p class="text-h6 text-brand-5 text-weight-bold">
            ATUALIZE PRODUTOS POR PLANILHA
          </p>
        </div>
        <infot-upload
          :infos="infosAtualize"
          :showUnidade="false"
          :activeSlide="activeSlide2"
          link="https://multpex-docs.s3.amazonaws.com/templates/controle-funcao/produtos_upload_r3.xlsx"
        />

        <div class="row items-center q-mt-md q-mb-md">
          <div class="col-4">
            <lista-unidades-select />
          </div>
        </div>

        <upload-planilha-layout
          titulo="Enviar planilha de atualização de produtos"
          :file="file2"
          :is-drag-over="isDragOver2"
          :submit-disabled="!file2"
          @drag-over="isDragOver2 = true"
          @drag-leave="isDragOver2 = false"
          @drop-file="onDrop(2, $event)"
          @file-selected="(e) => onFileSelected(2, e)"
          @instructions="activeSlide2 = !activeSlide2"
          @submit="enviar(2, mapeamentoAtualizacao)"
        />
      </q-tab-panel>

      <!-- ===== REMOVA ITENS ===== -->
      <q-tab-panel name="remova">
        <div class="row col-12">
          <p class="text-h6 text-brand-5 text-weight-bold">
            REMOVA ITENS DO CATÁLOGO
          </p>
        </div>
        <infot-upload
          :infos="infosRemova"
          link="https://multpex-docs.s3.amazonaws.com/templates/controle-funcao/produtos_remover_r0.xlsx"
          :showUnidade="false"
          :activeSlide="activeSlide3"
        />

        <div class="row items-center q-mt-md q-mb-md">
          <div class="col-4">
            <lista-unidades-select />
          </div>
        </div>

        <upload-planilha-layout
          titulo="Enviar planilha de remoção de itens"
          :file="file3"
          :is-drag-over="isDragOver3"
          :submit-disabled="!file3"
          @drag-over="isDragOver3 = true"
          @drag-leave="isDragOver3 = false"
          @drop-file="onDrop(3, $event)"
          @file-selected="(e) => onFileSelected(3, e)"
          @instructions="activeSlide3 = !activeSlide3"
          @submit="enviar(3, 'delete_produto')"
        />
      </q-tab-panel>

      <!-- ===== ZERAR PONTOS ===== -->
      <q-tab-panel name="zerar">
        <div class="row col-12">
          <p class="text-h6 text-brand-5 text-weight-bold">
            ZERAR PONTOS DE REPOSIÇÃO DOS ITENS
          </p>
        </div>
        <infot-upload
          :infos="infosZerar"
          link="https://multpex-docs.s3.amazonaws.com/templates/controle-funcao/produtos_zerar_pontos_r0.xlsx"
          :showUnidade="false"
          :activeSlide="activeSlide4"
        />

        <div class="row items-center q-mt-md q-mb-md">
          <div class="col-4">
            <lista-unidades-select />
          </div>
        </div>

        <upload-planilha-layout
          titulo="Enviar planilha para zerar pontos de reposição"
          :file="file4"
          :is-drag-over="isDragOver4"
          :submit-disabled="!file4"
          @drag-over="isDragOver4 = true"
          @drag-leave="isDragOver4 = false"
          @drop-file="onDrop(4, $event)"
          @file-selected="(e) => onFileSelected(4, e)"
          @instructions="activeSlide4 = !activeSlide4"
          @submit="enviar(4, 'zerar_limites_produto')"
        />
      </q-tab-panel>

      <!-- ===== DESATIVAR LOTE ===== -->
      <q-tab-panel name="desativar">
        <div class="row col-12">
          <p class="text-h6 text-brand-5 text-weight-bold">
            DESATIVAR CONTROLE DE LOTE
          </p>
        </div>
        <infot-upload
          :infos="infosDesativar"
          link="https://multpex-docs.s3.amazonaws.com/templates/controle-funcao/produtos_zerar_pontos_r0.xlsx"
          :showUnidade="false"
          :activeSlide="activeSlide5"
        />

        <div class="row items-center q-mt-md q-mb-md">
          <div class="col-4">
            <lista-unidades-select />
          </div>
        </div>

        <upload-planilha-layout
          titulo="Enviar planilha para desativar controle de lote"
          :file="file5"
          :is-drag-over="isDragOver5"
          :submit-disabled="!file5"
          @drag-over="isDragOver5 = true"
          @drag-leave="isDragOver5 = false"
          @drop-file="onDrop(5, $event)"
          @file-selected="(e) => onFileSelected(5, e)"
          @instructions="activeSlide5 = !activeSlide5"
          @submit="enviar(5, 'desativacao_lote')"
        />
      </q-tab-panel>
    </q-tab-panels>
  </q-page>
</template>

<script>
import InfotUpload from "../../compras/components/InfotUpload.vue";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import { ref, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import PageHeader from "../../../../components/PageHeader.vue";
import UploadPlanilhaLayout from "../../../../components/UploadPlanilhaLayout.vue";

export default {
  components: {
    InfotUpload,
    ListaUnidadesSelect,
    PageHeader,
    UploadPlanilhaLayout,
  },

  setup() {
    const store = useStore();
    const $q = useQuasar();

    const activeSlide = ref(false);
    const activeSlide2 = ref(false);
    const activeSlide3 = ref(false);
    const activeSlide4 = ref(false);
    const activeSlide5 = ref(false);

    const file1 = ref(null);
    const file2 = ref(null);
    const file3 = ref(null);
    const file4 = ref(null);
    const file5 = ref(null);

    const fileInput1 = ref(null);
    const fileInput2 = ref(null);
    const fileInput3 = ref(null);
    const fileInput4 = ref(null);
    const fileInput5 = ref(null);

    const isDragOver1 = ref(false);
    const isDragOver2 = ref(false);
    const isDragOver3 = ref(false);
    const isDragOver4 = ref(false);
    const isDragOver5 = ref(false);

    const files = { 1: file1, 2: file2, 3: file3, 4: file4, 5: file5 };

    const mapeamentoAtualizacao = computed(() => {
      const cliente = store.state.autenticacao.cliente || "";
      const isAcciona =
        cliente.includes("acciona") || cliente.includes("staging-acciona");
      return isAcciona ? "produto_edicao_acciona" : "produto";
    });

    const formatFileSize = (bytes) => {
      if (!bytes) return "0 Bytes";
      const k = 1024;
      const sizes = ["Bytes", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    };

    const onFileSelected = (tab, e) => {
      if (e.target.files[0]) files[tab].value = e.target.files[0];
    };

    const onDrop = (tab, e) => {
      const dragRefs = {
        1: isDragOver1,
        2: isDragOver2,
        3: isDragOver3,
        4: isDragOver4,
        5: isDragOver5,
      };
      dragRefs[tab].value = false;
      const f = e.dataTransfer.files[0];
      if (f && f.name.endsWith(".xlsx")) {
        files[tab].value = f;
      } else {
        $q.notify({
          message: "Por favor, selecione apenas arquivos .xlsx",
          color: "negative",
          icon: "warning",
        });
      }
    };

    const enviarParaN8n = async (planilhaBase64, mapeamento) => {
      const n8nEndpoint =
        "https://n8n.devops.multpex.com.br/webhook/356d6cf5-5d36-4a04-8759-0eb4b8f150c6";
      const payload = {
        planilha: planilhaBase64,
        mapeamento,
        unidade: store.state.org.unidadeData.nome,
        tenant: store.state.autenticacao.cliente[0],
        timestamp: new Date().toISOString(),
        origem: "catalogo-upload",
      };
      const response = await fetch(n8nEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      if (!response.ok) {
        throw new Error(
          `Erro HTTP: ${response.status} - ${response.statusText}`
        );
      }
      return await response.json();
    };

    const enviar = async (tab, mapeamento) => {
      const fileRef = files[tab];
      if (!fileRef.value || !fileRef.value.name.endsWith(".xlsx")) {
        $q.notify({
          message: "Por favor, selecione apenas arquivos .xlsx",
          color: "negative",
          icon: "warning",
        });
        return;
      }

      $q.loading.show({ message: "Enviando planilha..." });

      try {
        const result = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(fileRef.value);
          reader.onload = () => resolve(reader.result);
          reader.onerror = () => reject(reader.error);
        });

        const response = await store.dispatch("catalogo/uploads", {
          planilha: result,
          mapeamento,
          unidade: store.state.org.unidadeData.id,
        });

        $q.loading.hide();
        $q.notify({
          message:
            response.data?.result ||
            response.data?.message ||
            "Template enviado com sucesso",
          color: "positive",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });

        try {
          await enviarParaN8n(result, mapeamento);
        } catch (n8nError) {
          console.error("Erro ao enviar para n8n:", n8nError);
          $q.notify({
            message: "Template enviado, mas falha no processamento secundário",
            color: "warning",
            actions: [{ label: "Fechar", color: "white", handler: () => {} }],
          });
        }

        fileRef.value = null;
      } catch (error) {
        $q.loading.hide();
        const errorMessage =
          error.response?.data?.result?.error ||
          error.response?.data?.error ||
          error.response?.data?.message ||
          error.response?.data?.result ||
          "Erro ao enviar template";
        $q.notify({
          message: errorMessage,
          color: "negative",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });
      }
    };

    const infosCrie = ref([
      {
        name: "Não altere a ordem das colunas nem o texto, isso trará problema na importação",
        icon: "do_not_disturb",
      },
      {
        name: "Os dados da coluna A e B, código e descrição são obrigatórios",
        icon: "star",
      },
      {
        name: "Caso a informação de Categoria e Grupo de Produto tiver erro de digitação, o sistema criará uma nova categoria e grupo",
        icon: "warning",
      },
      {
        name: "O processamento é feito em segundo plano, e pode levar até 30 minutos, você receberá no seu email o status da importação",
        icon: "schedule",
      },
    ]);

    const infosAtualize = ref([
      {
        name: "Não altere a ordem das colunas nem o texto, isso trará problema na importação",
        icon: "do_not_disturb",
      },
      {
        name: "Os dados da coluna A e B, código e descrição são obrigatórios",
        icon: "star",
      },
      {
        name: "Caso a informação de Categoria e Grupo de Produto tiver erro de digitação, o sistema criará uma nova categoria e grupo",
        icon: "warning",
      },
      {
        name: "O processamento é feito em segundo plano, e pode levar até 30 minutos, você receberá no seu email o status da importação",
        icon: "schedule",
      },
    ]);

    const infosRemova = ref([
      {
        name: "O template possui apenas uma coluna, e nela é indicado o código do produto",
        icon: "view_column",
      },
      {
        name: "Verifique que o saldo do material está zerado para que a remoção seja bem sucedida",
        icon: "warning",
      },
      {
        name: "O processamento é feito em segundo plano, e pode levar até 30 minutos, você receberá no seu email o status da importação",
        icon: "schedule",
      },
    ]);

    const infosZerar = ref([
      {
        name: "O template possui apenas uma coluna, e nela é indicado o código do produto",
        icon: "view_column",
      },
      {
        name: "O processamento é feito em segundo plano, e pode levar até 30 minutos, você receberá no seu email o status da importação",
        icon: "schedule",
      },
    ]);

    const infosDesativar = ref([
      {
        name: "O template possui apenas uma coluna, e nela é indicado o código do produto",
        icon: "view_column",
      },
      {
        name: "O processamento é feito em segundo plano, e pode levar até 30 minutos, você receberá no seu email o status da importação",
        icon: "schedule",
      },
    ]);

    return {
      activeSlide,
      activeSlide2,
      activeSlide3,
      activeSlide4,
      activeSlide5,
      file1,
      file2,
      file3,
      file4,
      file5,
      fileInput1,
      fileInput2,
      fileInput3,
      fileInput4,
      fileInput5,
      isDragOver1,
      isDragOver2,
      isDragOver3,
      isDragOver4,
      isDragOver5,
      mapeamentoAtualizacao,
      formatFileSize,
      onFileSelected,
      onDrop,
      enviar,
      infosCrie,
      infosAtualize,
      infosRemova,
      infosZerar,
      infosDesativar,
      tab: ref("crie"),
    };
  },
};
</script>

<style scoped>
.upload-section {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 16px;
  padding: 24px;
  margin: 16px 0;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.upload-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  gap: 12px;
}

.header-icon {
  color: #1976d2;
}

.upload-title {
  margin: 0;
  color: #2c3e50;
  font-weight: 600;
  font-size: 1.1rem;
}

.upload-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.upload-area {
  background: white;
  border: 2px dashed #e0e4e7;
  border-radius: 12px;
  padding: 32px;
  text-align: center;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.upload-area:hover {
  border-color: #1976d2;
  background: #f8fafe;
  transform: translateY(-2px);
  box-shadow: 0 4px 20px rgba(25, 118, 210, 0.1);
}

.upload-area.file-selected {
  border-color: #4caf50;
  background: #f1f8e9;
}

.upload-area.drag-over {
  border-color: #1976d2;
  background: #e3f2fd;
  transform: scale(1.02);
}

.upload-zone {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.upload-icon-container {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}

.upload-icon {
  color: white;
}

.upload-text-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.upload-main-text {
  margin: 0;
  color: #546e7a;
  font-size: 1rem;
  font-weight: 500;
}

.upload-main-text.selected {
  color: #2e7d32;
  font-weight: 600;
}

.upload-button {
  cursor: pointer;
}

.upload-btn {
  min-width: 180px;
  height: 44px;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease;
}

.upload-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}

.file-info {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #e0e4e7;
}

.file-details {
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
}

.upload-actions {
  display: flex;
  justify-content: center;
}

.send-button {
  min-width: 160px;
  height: 44px;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease;
}

.send-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}
</style>
